export const GENERATE_ONBOARD_LINK = "GENERATE_ONBOARD_LINK";
export const GENERATE_ONBOARD_LINK_SUCCESS = "GENERATE_ONBOARD_LINK_SUCCESS";
export const GENERATE_ONBOARD_LINK_FAILED = "GENERATE_ONBOARD_LINK_FAILED";

export const SAVE_NPS_BASIC_DETAILS = "SAVE_NPS_BASIC_DETAILS";
export const SAVE_NPS_BANK_DETAILS = "SAVE_NPS_BANK_DETAILS";

export const SAVE_NPS_REJECTION_DETAILS = "SAVE_NPS_REJECTION_DETAILS";

export const SAVE_NPS_STATUS = "SAVE_NPS_STATUS";
export const SAVE_NPS_ACTIVE_BODY = "SAVE_NPS_ACTIVE_BODY";

export const SAVE_AGENT_REFNO = "SAVE_AGENT_REFNO";
